import React from "react";
import getSymbolFromCurrency from "currency-symbol-map";

const OrderDetail = ({ data, status, newStatus, setNewStatus, currency }) => {

  // SAFE DATE FORMATTER
  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    let d = date.toDateString();
    let hrs = date.getHours();
    let mins = date.getMinutes();
    let ampm = hrs >= 12 ? "PM" : "AM";

    hrs = hrs % 12 || 12;
    mins = mins < 10 ? "0" + mins : mins;

    return `${d}, ${hrs}:${mins} ${ampm}`;
  };

  // ADDRESS BUILDER
  const getAddress = (address) => {
    if (!address) return "Address deleted";

    return [
      address.Address_Line_1,
      address.Address_Line_2,
      address.City,
      address.State,
      address.Country,
      address.Pin_Code,
    ]
      .filter(Boolean)
      .join(", ");
  };

  return (
    <div>

      {/* ================= Left Side Info ================= */}
      <div className="row">
        <div className="col-lg-8">
          <div className="card">
            <div className="card-body">

              <table>
                <tbody>

                  <tr>
                    <td width="150"><strong>Order Date</strong></td>
                    <td>{formatDate(data.createdAt)}</td>
                  </tr>

                  <tr>
                    <td><strong>Order ID</strong></td>
                    <td>{data.orderID}</td>
                  </tr>

                  <tr>
                    <td><strong>Items</strong></td>
                    <td>{data.orderItems?.length || 0}</td>
                  </tr>

                  <tr>
                    <td><strong>Total Amount</strong></td>
                    <td>
                      {getSymbolFromCurrency(data.currency || "USD")}{" "}
                      {data.total_amount}
                    </td>
                  </tr>

                  <tr>
                    <td><strong>Shipping Address</strong></td>
                    <td>{getAddress(data.shippingInfo)}</td>
                  </tr>

                  <tr>
                    <td><strong>Customer Name</strong></td>
                    <td>{data.shippingInfo?.Name || "N/A"}</td>
                  </tr>

                  <tr>
                    <td><strong>Mobile</strong></td>
                    <td>{data.shippingInfo?.Contact_Number || "N/A"}</td>
                  </tr>

                  <tr>
                    <td><strong>Payment Mode</strong></td>
                    <td>{data.paymentMode}</td>
                  </tr>

                  <tr>
                    <td><strong>Payment Status</strong></td>
                    <td>{data.payment_status}</td>
                  </tr>

                </tbody>
              </table>

            </div>
          </div>
        </div>

        {/* ================= Right Side Status ================= */}
        <div className="col-lg-4">
          <div className="card">
            <div className="card-body">

              <table>
                <tbody>
                  <tr>
                    <td><strong>Order Status:</strong></td>
                    <td>{data.orderStatus}</td>
                  </tr>
                </tbody>
              </table>

              <div className="form-group mt-3">
                <label className="label-100">Change Status</label>

                <select
                  className="form-control input-field"
                  onChange={(e) => setNewStatus(e.target.value)}
                >
                  <option value="">--select--</option>

                  {data.orderStatus === "new" && (
                    <>
                      <option value="processing">Processing</option>
                      <option value="cancelled">Cancelled</option>
                    </>
                  )}

                  {data.orderStatus === "processing" && (
                    <option value="dispatched">Dispatched</option>
                  )}

                  {data.orderStatus === "dispatched" && (
                    <option value="delivered">Delivered</option>
                  )}

                  {data.orderStatus === "delivered" && (
                    <option value="returned">Returned</option>
                  )}

                </select>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* ================= Products Table ================= */}
      <div className="row mt-3">
        <div className="col-lg-8">
          <div className="card">
            <div className="card-body">

            <table className="table table-bordered">
  <thead className="bg-light">
    <tr>
      <th style={{ width: 250 }}>Product</th>
      <th className="text-center">Qty</th>
      <th className="text-right">Price</th>
      <th className="text-center">VAT (%)</th>
      <th className="text-right">VAT Amount</th>
      <th className="text-right">Subtotal</th>
    </tr>
  </thead>

  <tbody>
    {data.orderItems?.length ? (
      data.orderItems.map((item) => (
        <tr key={item._id}>

          {/* PRODUCT IMAGE + NAME */}
          <td>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <img
                src={item.image?.[0]}
                alt=""
                style={{
                  height: 50,
                  width: 50,
                  objectFit: "cover",
                  borderRadius: 8,
                  border: "1px solid #eee",
                }}
              />
              <div>
                <strong>{item.name}</strong>
                {item.variant_Name && (
                  <div className="text-muted small">
                    Variant: {item.variant_Name}
                  </div>
                )}
                {item.vat_Name && (
                  <div className="text-muted small">
                    VAT Type: {item.vat_Name}
                  </div>
                )}
              </div>
            </div>
          </td>

          {/* QTY */}
          <td className="text-center">{item.quantity}</td>

          {/* PRICE */}
          <td className="text-right">
            {getSymbolFromCurrency(data.currency)} {item.price}
          </td>

          {/* VAT RATE */}
          <td className="text-center">{item.vat_rate}%</td>

          {/* VAT AMOUNT */}
          <td className="text-right">
            {getSymbolFromCurrency(data.currency)} {item.vat_amount}
          </td>

          {/* SUBTOTAL */}
          <td className="text-right">
            {getSymbolFromCurrency(data.currency)} {item.total_price}
          </td>

        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="6" className="text-center">No items found</td>
      </tr>
    )}
  </tbody>
</table>

            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default OrderDetail;
